/* eslint-disable */

/** unique or primary key constraints on table "argo.event" */
export enum ArgoEventConstraint {
  /** unique or primary key constraint on columns "event_id" */
  EventPkey = 'event_pkey',
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  EventUniqueName = 'event_unique_name',
  /** unique or primary key constraint on columns "event_type_id", "event_id" */
  UniqueEventTypeFk = 'unique_event_type_fk'
}

/** select columns of table "argo.event" */
export enum ArgoEventSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.event" */
export enum ArgoEventUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

